import { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import "../../../../assets/scss/global.scss";
import LoaderImg from "../../../../assets/images/loader.gif";
import { generateQueryString } from "../../../../core/utility/utility";
import { getApiUrl } from "../../../../utils/baseUrl";
import { toast } from "react-toastify";
import { getAccountsUrl } from "../../../../utils/accountsUrl";
const API_URL = "https://login.salesforce.com/services/oauth2/authorize";
const REDIRECT_URI = getAccountsUrl() + "user/salesforce-status";
const apiEndpoint = {
  validateClientId: getApiUrl("validateClientId"),
  saveSalesforceClientId: getApiUrl("saveSalesforceClientId"),
  saveSalesforceToken: getApiUrl("saveSalesforceToken"),
  getSalesforceUserDetails: getApiUrl("getSalesforceUserDetails"),
};
// const REDIRECT_URI = 'https://login.salesforce.com/oauth2/callback'
const SalesforceIntegration = (props) => {
  const [clientFieldID, setFieldClientId] = useState("");
  const [secretFieldCode, setFieldSecretCode] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [redirectSuccess, setRedirectSuccess] = useState(false);
  const { userDetails: { is_salesforce_active: isSalesforce } = {}, setLoader, loader } = props;

  const handleClick = async (data) => {
    setIsEnabled(true);
    const params = { clientId: data.clientID };
    axios.get(apiEndpoint.validateClientId, { params }).then((res) => {
      if (res && res.data.status && res.data.status !== "" && res.data.status.toLowerCase() === "success") {
        const UID = props && props.userDetails && props.userDetails.email ? props.userDetails.email : "";
        const requestObj = { response_type: "code", client_id: data.clientID, redirect_uri: REDIRECT_URI, state: UID };
        const saveRequestObj = { client_id: data.clientID, client_secret: data.secretCode, state: UID };
        saveClientInfo(saveRequestObj);
        let tempQueryString = generateQueryString(requestObj);
        if (!!tempQueryString && tempQueryString !== "") {
          tempQueryString = "?" + tempQueryString;
        }
        window.open(API_URL + tempQueryString);
      } else {
        toast.error(res.data.message);
      }
      setIsEnabled(false);
    });
  };
  const saveClientInfo = (data) => {
    const params = {
      client_id: data.client_id,
      client_secret: data.client_secret,
      uid: data.state,
    };
    axios.post(apiEndpoint.saveSalesforceClientId, params).then((res) => {
      if (res && res.data) {
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
      }
    });
  };
  const verifyToken = (param1, param2) => {
    const params = {
      code: param1,
      uid: param2,
    };
    axios.post(apiEndpoint.saveSalesforceToken, params).then((res) => {
      if (res && res.data && res.data.status.toLowerCase() === "success") {
        toast.success(res.data.message);
      } else {
        toast.error(res.data.message);
      }
    });
  };
  const getDetails = () => {
    setLoader(true);
    axios.get(apiEndpoint.getSalesforceUserDetails).then((res) => {
      if (res && res.data && res.data.data && res.data.data.client_id && res.data.data.client_secret && res.data.data.client_id !== "" && res.data.data.client_secret !== "") {
        setFieldClientId(res.data.data.client_id);
        setFieldSecretCode(res.data.data.client_secret);
        setDisabled(res.data.data.status.toLowerCase() === "complete" ? true : false);
        setRedirectSuccess(res.data.data.status.toLowerCase() === "complete" ? true : false);
        setLoader(false);
      } else {
        setLoader(false);
        toast.error(res.data.data.message);
      }
    });
  };
  useEffect(() => {
    const searchUrlParams = props.location.search;
    const accountsURL = props.location.pathname;
    if (accountsURL.includes("/salesforce-status") && new URLSearchParams(searchUrlParams).get("code") !== "" && new URLSearchParams(searchUrlParams).get("state") !== "") {
      if (props && props.userDetails && props.userDetails.is_admin === false) {
        setDisabled(true);
      }
      setTimeout(function () {
        verifyToken(new URLSearchParams(searchUrlParams).get("code"), new URLSearchParams(searchUrlParams).get("state"));
      }, 100);
    }
    setTimeout(() => {
      getDetails();
    }, 1000);
  }, []);

  return (
    <div className="container">
      {loader && isSalesforce ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "16px",
          }}
        >
          <img src={LoaderImg} alt="description of gif" />
        </div>
      ) : (
        <div className="salesforceContainer">
          <div className="card-body px-0">
            <div className="reset-form w-100">
              <Formik
                initialValues={{
                  clientID: clientFieldID ? clientFieldID : "",
                  secretCode: secretFieldCode ? secretFieldCode : "",
                }}
                enableReinitialize={true}
                validationSchema={Yup.object().shape({
                  clientID: Yup.string().min(6, "Client Id must be at least 6 characters").required("Client Id is required"),
                  secretCode: Yup.string().min(6, "Secret Code must be at least 6 characters").required("Secret Code is required"),
                })}
                onSubmit={(values, { setSubmitting }) => {
                  handleClick(values, setSubmitting);
                }}
                render={({ errors, touched }) => (
                  <Form>
                    <div className="form-group">
                      <label className="col-4 pl-0 client-id-label" htmlFor="clientID">
                        Enter Client Id
                      </label>
                      <Field name="clientID" type="text" disabled={disabled} className={"form-control col-12" + (errors.clientID && touched.clientID ? " is-invalid" : "")} />
                      <ErrorMessage name="clientID" component="div" className="invalid-feedback m-auto px-3" />
                    </div>
                    <div className="form-group">
                      <label className="col-4 pl-0 client-id-label" htmlFor="secretCode">
                        Enter Client Secret
                      </label>
                      <Field
                        name="secretCode"
                        type="text"
                        disabled={disabled}
                        className={`col-12 ${"form-control" + (errors.secretCode && touched.secretCode ? " is-invalid" : "")}`}
                      />
                      <ErrorMessage name="secretCode" component="div" className="invalid-feedback m-auto px-3" />
                    </div>
                    <div className="form-group">
                      <div className="col-12"></div>
                      {!!isEnabled && isEnabled === true ? (
                        <button className="col-12 btn btn-primary btn-change-password w-100" type="button" disabled>
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          <span className="sr-only">Loading...</span>
                        </button>
                      ) : (
                        <button type="submit" className="col-12 btn btn-primary btn-change-password w-100" disabled={disabled}>
                          {redirectSuccess ? "Connected" : "Connect to Salesforce"}
                        </button>
                      )}
                    </div>
                  </Form>
                )}
              ></Formik>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default SalesforceIntegration;
